"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductBoxList = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _EnergyLabel = require("b2b-components/core/components/EnergyLabel");
var _StockCount = require("b2b-components/theme/components/StockCount");
var _device = require("b2b-components/utils/device");
var _getComponentDataAttributes = require("b2b-components/utils/getComponentDataAttributes");
var _classnames = _interopRequireDefault(require("classnames"));
var _Features = require("../common/Features");
var _ImageLink = require("../common/ImageLink");
var _LabelList = require("../common/LabelList");
var _Title = require("../common/Title");
var _Variants = require("../common/Variants");
var _BulletPointList = require("./BulletPointList");
require("./ProductBoxList.scss");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var ProductBoxList = function ProductBoxList(_ref) {
  var basePrice = _ref.basePrice,
    category = _ref.category,
    className = _ref.className,
    imageUrl = _ref.imageUrl,
    manufacturerSku = _ref.manufacturerSku,
    onCategoryClick = _ref.onCategoryClick,
    onProductClick = _ref.onProductClick,
    price = _ref.price,
    sku = _ref.sku,
    renderSku = _ref.renderSku,
    stock = _ref.stock,
    title = _ref.title,
    dataAttributes = _ref.dataAttributes,
    _ref$bulletPoints = _ref.bulletPoints,
    bulletPoints = _ref$bulletPoints === void 0 ? [] : _ref$bulletPoints,
    _ref$deviceType = _ref.deviceType,
    deviceType = _ref$deviceType === void 0 ? _device.DEVICE_TYPE.desktop : _ref$deviceType,
    _ref$energyLabel = _ref.energyLabel,
    energyLabel = _ref$energyLabel === void 0 ? null : _ref$energyLabel,
    _ref$isForSlider = _ref.isForSlider,
    isForSlider = _ref$isForSlider === void 0 ? false : _ref$isForSlider,
    _ref$isCoreAssortment = _ref.isCoreAssortment,
    isCoreAssortment = _ref$isCoreAssortment === void 0 ? false : _ref$isCoreAssortment,
    _ref$isOwnAssortment = _ref.isOwnAssortment,
    isOwnAssortment = _ref$isOwnAssortment === void 0 ? false : _ref$isOwnAssortment,
    _ref$isNew = _ref.isNew,
    isNew = _ref$isNew === void 0 ? false : _ref$isNew,
    _ref$isOccasion = _ref.isOccasion,
    isOccasion = _ref$isOccasion === void 0 ? false : _ref$isOccasion,
    _ref$isPromotion = _ref.isPromotion,
    isPromotion = _ref$isPromotion === void 0 ? false : _ref$isPromotion,
    _ref$isSellout = _ref.isSellout,
    isSellout = _ref$isSellout === void 0 ? false : _ref$isSellout,
    _ref$isSpecialOrder = _ref.isSpecialOrder,
    isSpecialOrder = _ref$isSpecialOrder === void 0 ? false : _ref$isSpecialOrder,
    _ref$renderActions = _ref.renderActions,
    renderActions = _ref$renderActions === void 0 ? null : _ref$renderActions,
    _ref$renderHiddenPric = _ref.renderHiddenPrice,
    renderHiddenPrice = _ref$renderHiddenPric === void 0 ? null : _ref$renderHiddenPric,
    _ref$text = _ref.text,
    text = _ref$text === void 0 ? {
      sku: 'SKU',
      manufacturerSku: 'Manufacturer SKU',
      category: 'Category',
      variants: 'Also available in:',
      "new": 'new',
      promotion: 'promotion',
      sellout: 'sellout',
      occasion: 'occasion',
      coreAssortment: 'Core Assortment',
      ownAssortment: 'Customer specific assortment',
      stockCount: {
        date: '',
        deliveryDates: '',
        notReadyForShipment: '',
        orderedQuantity: '',
        readyForShipment: '',
        specialOrder: {
          full: '',
          "short": '',
          explanation: ''
        },
        seeMore: ''
      }
    } : _ref$text,
    _ref$url = _ref.url,
    url = _ref$url === void 0 ? '#' : _ref$url,
    _ref$quantityOrdered = _ref.quantityOrdered,
    quantityOrdered = _ref$quantityOrdered === void 0 ? null : _ref$quantityOrdered,
    _ref$variantCount = _ref.variantCount,
    variantCount = _ref$variantCount === void 0 ? 3 : _ref$variantCount,
    _ref$variants = _ref.variants,
    variants = _ref$variants === void 0 ? [] : _ref$variants,
    isMouseOver = _ref.isMouseOver,
    onMouseEnter = _ref.onMouseEnter,
    onMouseLeave = _ref.onMouseLeave;
  var hasLabels = isOwnAssortment || isCoreAssortment || isNew || isOccasion || isPromotion || isSellout;
  var rootClassName = (0, _classnames["default"])('cds-ProductBox', 'cds-ProductBox--List', {
    'cds-ProductBox--Hover': isMouseOver
  }, className);
  var LabelListComponent = (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react["default"].createElement(_LabelList.LabelList, {
      isCoreAssortment: isCoreAssortment,
      isOwnAssortment: isOwnAssortment,
      isNew: isNew,
      isOccasion: isOccasion,
      isPromotion: isPromotion,
      isSellout: isSellout,
      text: text
    });
  }, [isOwnAssortment, isCoreAssortment, isNew, isOccasion, isPromotion, isSellout, text]);
  var StockCountComponent = (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react["default"].createElement(_StockCount.StockCount, {
      className: "cds-ProductBox-StockCount",
      deviceType: deviceType,
      isSpecialOrder: isSpecialOrder,
      quantityOrdered: quantityOrdered,
      stockCount: stock,
      text: text.stockCount
    });
  }, [deviceType, isSpecialOrder, quantityOrdered, stock, text.stockCount]);
  var ImageLinkComponent = (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react["default"].createElement(_ImageLink.ImageLink, {
      imageUrl: imageUrl,
      onClick: onProductClick,
      title: title,
      url: url,
      sku: sku,
      className: (0, _classnames["default"])({
        'cds-ProductBox-ImageWrapper': hasLabels
      })
    });
  }, [imageUrl, onProductClick, title, sku, url, hasLabels]);
  var TitleComponent = (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react["default"].createElement(_Title.Title, {
      sku: sku,
      url: url,
      title: title,
      onClick: onProductClick
    });
  }, [onProductClick, title, url, sku]);
  var BulletPointListComponent = (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react["default"].createElement(_BulletPointList.BulletPointList, {
      bulletPoints: bulletPoints,
      className: energyLabel ? 'cds-ProductBox-BulletPointList--WithPadding' : undefined
    });
  }, [bulletPoints, energyLabel]);
  var EnergyLabelComponent = (0, _react.useMemo)(function () {
    if (energyLabel) {
      return /*#__PURE__*/_react["default"].createElement(_EnergyLabel.EnergyLabel, {
        className: "cds-ProductBox-EnergyLabel",
        range: energyLabel.range,
        rating: energyLabel.rating,
        size: _EnergyLabel.EnergyLabel.config.size.small
      });
    }
    return null;
  }, [energyLabel]);
  var FeaturesComponent = (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react["default"].createElement(_Features.Features, {
      basePrice: basePrice,
      category: category,
      manufacturerSku: manufacturerSku,
      onCategoryClick: onCategoryClick,
      price: price,
      renderActions: renderActions,
      renderHiddenPrice: renderHiddenPrice,
      sku: sku,
      renderSku: renderSku,
      text: text,
      areActionsVisible: isMouseOver
    });
  }, [basePrice, category, manufacturerSku, onCategoryClick, price, renderActions, renderHiddenPrice, renderSku, sku, text, isMouseOver]);
  var VariantsComponent = (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react["default"].createElement(_Variants.Variants, {
      onProductClick: onProductClick,
      text: text,
      url: url,
      variantCount: variantCount,
      variants: variants
    });
  }, [onProductClick, text, url, variantCount, variants]);
  var renderProductBox = (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, (0, _getComponentDataAttributes.getComponentDataAttributes)(dataAttributes), {
      className: rootClassName,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave
    }), StockCountComponent, ImageLinkComponent, /*#__PURE__*/_react["default"].createElement("div", {
      className: "cds-ProductBox-Wrapper"
    }, LabelListComponent, TitleComponent, /*#__PURE__*/_react["default"].createElement("div", {
      className: "cds-ProductBox-Details"
    }, BulletPointListComponent, EnergyLabelComponent, FeaturesComponent), VariantsComponent));
  }, [BulletPointListComponent, EnergyLabelComponent, FeaturesComponent, ImageLinkComponent, LabelListComponent, StockCountComponent, TitleComponent, VariantsComponent, dataAttributes, onMouseEnter, onMouseLeave, rootClassName]);
  return isForSlider ? renderProductBox : /*#__PURE__*/_react["default"].createElement("li", {
    className: "cds-ProductBoxWrapper"
  }, renderProductBox);
};
exports.ProductBoxList = ProductBoxList;
ProductBoxList.BulletPointList = _BulletPointList.BulletPointList;
ProductBoxList.EnergyLabel = _EnergyLabel.EnergyLabel;
ProductBoxList.Features = _Features.Features;
ProductBoxList.ImageLink = _ImageLink.ImageLink;
ProductBoxList.LabelList = _LabelList.LabelList;
ProductBoxList.StockCount = _StockCount.StockCount;
ProductBoxList.Title = _Title.Title;
ProductBoxList.Variants = _Variants.Variants;